export default {
  header() {
    var sticked = false;
    var header = $(".o-header");

    if (header.css("display") === "none") {
      header = $(".mobileHeader");
    }

    if ($(window).width() > 992) {
      $("body").css("margin-top", header.outerHeight() + "px");
    } else {
      $("body").css("margin-top", $(".o-mobileHeader").outerHeight() + "px");
    }

    $(window).on("scroll", () => {
      let scroll = $(window).scrollTop();

      if (!sticked && scroll > header.outerHeight()) {
        sticked = true;
        stick();
      } else if (sticked && scroll <= header.outerHeight()) {
        sticked = false;
        unstick();
      }
    });

    function stick() {
      $(".menu-search__wrapper").hide();

      header.addClass("o-header--sticky");
    }

    function unstick() {
      header.removeClass("o-header--sticky");

      $(".menu-search__wrapper").fadeIn(300);
    }
  },
};
